export default function templePriceModals() {
  const dialogs = document.querySelectorAll('.temple-price-modal');
  if (!dialogs.length) return;

  document.querySelectorAll('[data-price-modal-row]').forEach(row => {
    row.addEventListener('click', event => {
      if (event.target.closest('.tooltip-group')) return;
      const dialog = document.getElementById(row.dataset.priceModalRow);
      if (!dialog || dialog.open) return;
      const trigger = event.target.closest('[data-price-modal-open]') || row.querySelector('[data-price-modal-open]');
      trigger.focus({ preventScroll: true });
      dialog.showModal();
      document.body.classList.add('is-price-modal-open');
    });
  });

  dialogs.forEach(dialog => {
    dialog.querySelector('[data-price-modal-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => {
      if (event.target === dialog) dialog.close();
    });
    dialog.addEventListener('close', () => {
      if (!document.querySelector('.temple-price-modal[open]')) document.body.classList.remove('is-price-modal-open');
    });
    dialog.querySelector('[data-price-modal-reservation]').addEventListener('click', () => {
      dialog.close();
      document.body.classList.remove('is-price-modal-open');
    });
  });
}
